// extracted by mini-css-extract-plugin
export default {"copy":"fZHZT","termsLinkText":"MUoFi","header":"kpLey","loyaltyOptInModal":"rvukM","icon":"C8gMt"};